<template>
  <div class="ta-bid-placed-message">
    <div class="ta-success-icon">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
        <path fill-rule="evenodd"
              d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm13.36-1.814a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z"
              clip-rule="evenodd"/>
      </svg>
    </div>
    <div class="ta-success-message">
      {{ label }}
    </div>
  </div>
</template>

<script>
export default {
  name: "BidPlacedMessage",
  props: {
    label: {
      type: String,
      default() {
        return this.$t('Bid Placed!')
      }
    }
  },
}
</script>

<style lang="scss" scoped>
@import "../../bootstrap/import";

.ta-bid-placed-message {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.ta-success-icon {
  color: $success;
  svg {
    width: 48px;
  }
}
.ta-success-message {
  font-size: 28px;
  font-weight: bold;
}
</style>
